import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

// Lazy load guards and layouts
const HasToBeLoggedInGuard = lazy(() => import('app/core/guards/HasToBeLoggedInGuard'));
const DefaultLayout = lazy(() => import('app/core/layout/DefaultLayout'));
const Error404Page = lazy(() => import('app/main/errors/Error404Page'));
const HasToBeAllowedForInspectionsGuard = lazy(() =>
  import('../../guards/HasToBeAllowedForInspectionsGuard').then((m) => ({
    default: m.HasToBeAllowedForInspectionsGuard,
  })),
);

// Lazy load page components

const InspectionReportPage = lazy(
  () => import('../../../main/dcra-inspections/inspection-report/InspectionReportPage'),
);

const JobCreatePage = lazy(() => import('../../../main/dcra-inspections/job-create/JobCreatePage'));
const InspectionsPage = lazy(() => import('../../../main/dcra-inspections/inspections/InspectionsPage'));
const InspectionDetailsPage = lazy(() => import('../../../main/construction/inspections/InspectionDetailsPage'));

const PREFIX = '/dcra-inspections';

const dcraInspectionRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeAllowedForInspectionsGuard>
          <DefaultLayout />
        </HasToBeAllowedForInspectionsGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'inspection-create/:type',
        element: (
          <Suspense fallback={<DataLoader />}>
            <JobCreatePage />
          </Suspense>
        ),
      },
      {
        path: 'inspection-create',
        element: (
          <Suspense fallback={<DataLoader />}>
            <JobCreatePage />
          </Suspense>
        ),
      },
      {
        path: 'inspections/:sectionId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionsPage />
          </Suspense>
        ),
      },
      {
        path: 'inspections',
        element: <Navigate to={'scheduled'} />,
      },
      {
        path: 'inspection/:id/report',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionReportPage />
          </Suspense>
        ),
      },
      {
        path: 'inspection/:id',
        element: <Suspense fallback={<DataLoader />}>{<InspectionDetailsPage />}</Suspense>,
      },
    ],
  },
  {
    path: '/',
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeAllowedForInspectionsGuard>
          <DefaultLayout />
        </HasToBeAllowedForInspectionsGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'dir/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionReportPage />
          </Suspense>
        ),
      },

      {
        path: 'di/:id',
        element: <Suspense fallback={<DataLoader />}>{<InspectionDetailsPage />}</Suspense>,
      },
    ],
  },
];

export default dcraInspectionRoutes;
